// extracted by mini-css-extract-plugin
export default {"root":"QuoteSection_root__b9Ry8","image":"QuoteSection_image__e0VbW","text":"QuoteSection_text__xAP5f"};